import React from "react"
import LogoLight from "../../static/images/logo_light.png"

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <div className="content">
          <img
            className="logo"
            src={LogoLight}
            alt=""
          />
          <p>Copyright © 2003 - 2020 <span>Conjecture Corporation</span></p>
        </div>
      </footer>
    )
  }
}

export default Footer
